import i18n from "@/i18n";

/**
 * Fristående i18next-instans låst till engelska. Används av /en-sidorna så att
 * servern renderar engelska direkt (SEO + inga textväxlingar), utan att röra
 * det globala språket som styr de svenska URL:erna.
 */
export const enI18n = i18n.cloneInstance({ lng: "en" });
